import InputField from '../Forms/Input/InputField';
import { BusinessConfigurationForm } from '../../types/business/BusinessTypes';

interface Props {
  form: BusinessConfigurationForm;
  errors: Record<string, string>;
  onChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => void;
}

const CompanyInfoSection = ({ form, errors, onChange }: Props) => (
  <div className="p-0 sm:p-0 xl:p-0">
    <div className="mb-6">
      <h2 className="text-gray-800 text-lg font-semibold dark:text-white">
        Información de la Empresa
      </h2>
      <p className="text-gray-500 dark:text-gray-400 text-sm">
        Complete los datos básicos de su empresa. Algunos campos son
        obligatorios.
      </p>
    </div>

    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <InputField
        label="Nombre de la Empresa"
        name="businessName"
        value={form.businessName}
        onChange={onChange}
        iconKey="company"
        error={errors.businessName}
        type="text"
        required
        placeholder="Ejemplo: Tienda El Progreso S.A. de C.V."
      />

      <InputField
        label="Teléfono"
        name="phoneNumber"
        value={form.phoneNumber}
        onChange={onChange}
        iconKey="phone"
        error={errors.phoneNumber}
        type="text"
        required
        placeholder="Ejemplo: 2222-3333"
      />

      <InputField
        label="NIT"
        name="nit"
        value={form.nit}
        onChange={onChange}
        iconKey="document"
        error={errors.nit}
        type="text"
        required
        placeholder="Ejemplo: 0614-290190-101-3"
      />

      <InputField
        label="NRC"
        name="nrc"
        value={form.nrc}
        onChange={onChange}
        iconKey="document"
        error={errors.nrc}
        type="text"
        placeholder="Ejemplo: 123456-7"
      />

      <InputField
        label="Nombre del Contribuyente"
        name="taxpayerName"
        value={form.taxpayerName}
        onChange={onChange}
        iconKey="user"
        error={errors.taxpayerName}
        type="text"
        placeholder="Ejemplo: Juan Pérez López"
      />

      {/* ✅ Nuevo campo de correo electrónico */}
      <InputField
        label="Correo Electrónico"
        name="email"
        value={form.email || ''}
        onChange={onChange}
        iconKey="email"
        error={errors.email}
        type="email"
        placeholder="Ejemplo: empresa@correo.com"
      />
    </div>
  </div>
);

export default CompanyInfoSection;
